// Admin-only read-only staging export (full DB snapshot ZIP).
import { useState } from "react";
import api from "@/lib/api";
import { Download, Loader2, ShieldAlert } from "lucide-react";

export default function AdminStagingExportPage() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [started, setStarted] = useState(false);

  const start = async () => {
    setBusy(true); setError(""); setStarted(false);
    try {
      const { data } = await api.post("/admin/staging-export/ticket");
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/admin/staging-export/download?ticket=${encodeURIComponent(data.ticket)}`;
      const a = document.createElement("a");
      a.href = url;
      a.rel = "noopener";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setStarted(true);
    } catch (e) {
      setError(e?.response?.data?.detail || "Could not start the export.");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-2xl mx-auto px-6 py-10" data-testid="staging-export-page">
      <h1 className="text-3xl font-bold text-stone-900">Staging export</h1>
      <p className="mt-3 text-sm text-stone-600">
        Downloads a read-only ZIP snapshot of this HUB&apos;s database for migration testing.
        Nothing is changed. Secret tokens and sessions are excluded; settings are sanitised.
      </p>
      <div className="mt-5 flex gap-3 rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900" data-testid="staging-export-warning">
        <ShieldAlert className="h-5 w-5 shrink-0" />
        <span>The file contains personal data, including password hashes and ID numbers. Store it privately and delete it when finished.</span>
      </div>
      <button
        type="button"
        onClick={start}
        disabled={busy}
        data-testid="staging-export-download-btn"
        className="mt-6 inline-flex items-center gap-2 rounded-full bg-stone-900 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-stone-700 disabled:opacity-60"
      >
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
        Download staging export
      </button>
      {started && (
        <p className="mt-4 text-sm text-emerald-700" data-testid="staging-export-started">
          Download started — your browser will save the ZIP when it finishes. Large databases can take several minutes.
        </p>
      )}
      {error && <p className="mt-4 text-sm text-red-600" data-testid="staging-export-error">{error}</p>}
    </div>
  );
}
